import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DialogModule } from 'primeng/dialog';

import { CommunityTabsComponent } from 'src/app/share/community-tabs/community-tabs.component';
import { ForumHomeComponent } from './forum-home/forum-home.component';
import { ForumPostCardComponent } from './forum-post-card/forum-post-card.component';
import { ForumPostDetailComponent } from './forum-post-detail/forum-post-detail.component';
import { ForumCommunityComponent } from './forum-community/forum-community.component';

@NgModule({
  declarations: [
    ForumHomeComponent,
    ForumPostCardComponent,
    ForumPostDetailComponent,
    ForumCommunityComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    DialogModule,
    CommunityTabsComponent, // standalone
  ],
})
export class ForumModule {}
